import React from "react"
import { Button, Modal } from "react-bootstrap"
import FilterClients from "../../../../Clients/components/Filter"
import styled from "styled-components"

import POSSaleContext from "../../../context"

const ClientArea = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
padding-top: 20px;
padding-bottom: 20px;
text-alig: center;
`
const ClientAreaIcon = styled.div`
cursor: pointer;
text-alig:center;
`

export default class POSSaleClient extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            show: false
        }
        this._openModalSelectClient = this._openModalSelectClient.bind(this)
        this._closeModalSelectClient = this._closeModalSelectClient.bind(this)
        this._setClientToSale = this._setClientToSale.bind(this)
    }
    _openModalSelectClient() {
        this.setState({ ...this, show: true })
    }
    _closeModalSelectClient() {
        this.setState({ ...this, show: false })
    }
    _setClientToSale(e) {
        this.props.onSetClient(e)
        this._closeModalSelectClient()
    }

    render() {
        return <POSSaleContext.Consumer>
            {
                sale => {
                    return <div className={this.props.className}>
                        {
                            sale.client_name
                                ? <ClientArea>
                                    <div>
                                        <p
                                            className="lead">{sale.client_name}
                                        </p>
                                    </div>
                                    <div>
                                        <ClientAreaIcon>
                                            <i
                                                onClick={this.props.removeClient}
                                                title="Remover cliente"
                                                className="fas fa-close text-danger" />
                                        </ClientAreaIcon>
                                    </div>
                                </ClientArea>
                                : <Button
                                    onClick={this._openModalSelectClient}
                                    className="w-100 dim py-2"
                                    variant="primary">
                                    Cliente
                                </Button>
                        }
                        <Modal
                            show={this.state.show}
                            size="lg"
                            onHide={this._closeModalSelectClient} >
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    Selecione o cliente
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <FilterClients onClick={this._setClientToSale} />
                            </Modal.Body>
                        </Modal>
                    </div>
                }
            }

        </POSSaleContext.Consumer>
    }
}


// WEBPACK FOOTER //
// ./src/views/AppViews/POS/components/FooterActionsPOS/SaleClient/index.jsx